import {FiEdit, FiTrash} from "react-icons/fi";

import {Icon} from "@/components/icon/Icon.tsx";
import {ButtonAction, QuickActionsBar} from "@/components/quickActionsBar/QuickActionsBar.tsx";
import {EmptyTable} from "@/components/table/subComponents/EmptyTable/EmptyTable.tsx";
import {Table} from "@/components/table/Table.tsx";
import {ColumnSpec} from "@/components/table/Table.types.ts";
import {Tooltip} from "@/components/toolTip/Tooltip.tsx";
import {SLAReportGroupInput} from "@/lib/queries/reports.ts";

import styles from "./SLAReportGroupTable.module.scss";

interface SLAReportGroupTableProps {
  groups: SLAReportGroupInput[];
  onEdit: (group: SLAReportGroupInput) => void;
  onDelete: (group: SLAReportGroupInput) => void;
  isFiltered?: boolean;
}

export const SLAReportGroupTable = ({groups, onEdit, onDelete, isFiltered}: SLAReportGroupTableProps) => {
  const specs: ColumnSpec<SLAReportGroupInput>[] = [
    {
      fieldName: "name",
      fieldTitle: "Name",
      meta: {headerClassName: styles.nameCell},
      accessor: ({name}) => (
        <Tooltip tooltipContent={name} delayMs={1000} onModal>
          <div className="ellipsis-overflow">{name}</div>
        </Tooltip>
      ),
    },
    {
      fieldName: "num_checks",
      fieldTitle: "Checks Selected",
      meta: {headerClassName: styles.checkCell},
      accessor: ({group_services}) => group_services.length,
    },
    {
      fieldName: "quick_actions",
      meta: {headerClassName: styles.actionCell},
      accessor: (group) => (
        <QuickActionsBar
          id={`sla-report-group-${group.name}`}
          actions={[
            <ButtonAction onClick={() => onEdit(group)} tooltip="Edit Group">
              <Icon icon={FiEdit} />
            </ButtonAction>,
            <ButtonAction onClick={() => onDelete(group)} tooltip="Delete Group">
              <Icon icon={FiTrash} />
            </ButtonAction>,
          ]}
        />
      ),
    },
  ];

  return (
    <Table
      fixedWidth
      minWidth={"400px"}
      rows={groups}
      specs={specs}
      initialState={{columnPinning: {right: ["quick_actions"]}}}
      noDataComponent={
        <EmptyTable colSpan={specs.length} className="p-5">
          <div className="pulseTextBodySmall pulse-color-gray-700 text-center">
            {isFiltered ? (
              "No groups found matching your search above."
            ) : (
              <>
                <div>You haven’t added any groups yet.</div>
                <div>Add a name and select Checks above to create a new group.</div>
              </>
            )}
          </div>
        </EmptyTable>
      }
    />
  );
};
